import { useTranslation } from 'react-i18next';

import PageNav from '../page-nav';
import {
  LatestIcon,
  PersonIcon,
  ResourcesIcon,
  StarFeaturedIcon,
  TrendingIcon,
} from '../ui';

import { programSelectors } from '../../models/program';
import { usePatronSelector } from '../../common/use-patron-selector';

export const FilteredFeedNav = () => {
  const { t } = useTranslation();

  const resourcesEnabled = usePatronSelector((state) =>
    programSelectors.getProgramResourcesEnabled(state)
  );
  const forYouFeedEnabled = usePatronSelector((state) =>
    programSelectors.getForYouFeedEnabled(state)
  );

  const navItems = [];
  if (resourcesEnabled) {
    navItems.push({
      title: t('menu.resources'),
      url: '/feed/resources',
      iconComponent: <ResourcesIcon />,
    });
  }
  navItems.push(
    ...[
      {
        title: t('content.featured'),
        url: '/feed/featured',
        iconComponent: <StarFeaturedIcon />,
      },
      {
        title: t('landing.latest'),
        url: '/feed/latest',
        iconComponent: <LatestIcon />,
      },
      {
        title: t('landing.trending'),
        url: '/feed/trending',
        iconComponent: <TrendingIcon />,
      },
    ]
  );
  if (forYouFeedEnabled) {
    navItems.push({
      title: t('landing.for_you'),
      url: '/feed/for_you',
      iconComponent: <PersonIcon />,
    });
  }

  return <PageNav items={navItems} />;
};
